@if (isVisible()) {
  <div class="calculator-wrapper" [ngClass]="{overlay: overlay()}">
    <ms-calculator [standalone]="true" (keydown)="onKeydown($event)"/>
  </div>
}
